<div id="stay22-widget-container">
    <h2 class="title heading-medium" translate="shared.labels.stay22Title"></h2>
    <iframe [src]="stay22UrlSafe" id="stay22-widget" width="100%" height="460" frameborder="0"></iframe>
    <p translate="shared.labels.stay22Text"></p>
</div>
